import { LocalStorageKey } from '../enums/LocalStorageKey'
import { safeGetJson, safeSetItem } from './safeStorage'

export default class LocalStorageHelper {
  public static setUserPreferences(
    userId: string,
    preferences: { [key in LocalStorageKey]?: any },
  ) {
    const userPreferences = safeGetJson<Record<string, any>>(userId) || {}
    Object.assign(userPreferences, preferences)
    safeSetItem(userId, JSON.stringify(userPreferences))
  }

  public static getUserPreferenceByKey(
    userId: string,
    preferenceKey: LocalStorageKey,
  ): string {
    const userPreferences = safeGetJson<Record<string, any>>(userId) || {}
    return userPreferences[preferenceKey] || ''
  }
}
